import React from "react";
import { Link } from "react-router-dom";
import { Atom, Mail } from "lucide-react";

const navItems = [
    { to: "/", label: "Home" },
    { to: "/products", label: "Catalog" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
];

export const Footer = () => {
    return (
        <footer className="relative border-t border-white/10 bg-[#05050A] mt-28" data-testid="site-footer">
            <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[160px] rounded-full bg-indigo-600/8 blur-[100px]" />

            <div className="relative max-w-7xl mx-auto px-5 lg:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 items-start">
                    {/* Brand */}
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-2.5 mb-5">
                            <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center shadow-[0_0_24px_rgba(99,102,241,0.35)]">
                                <Atom className="w-4 h-4 text-white" strokeWidth={2.2} />
                            </span>
                            <span className="font-light tracking-[-0.02em] text-xl">
                                Quantum<span className="text-indigo-400 font-medium"> Genesis Labs</span>
                            </span>
                        </div>
                        <p className="text-sm text-slate-400 max-w-md leading-relaxed">
                            A curated catalog of premium research-grade peptides — high-purity lyophilized formulations,
                            carefully sourced and professionally presented.
                        </p>
                        <p className="mt-6 text-[10px] uppercase tracking-[0.32em] text-indigo-400/90">
                            For Research Purposes Only
                        </p>
                        <a
                            href="mailto:info@quantumgenesislabs.com"
                            data-testid="footer-email-link"
                            className="mt-6 inline-flex items-center gap-2 group"
                        >
                            <span className="inline-flex w-8 h-8 rounded-lg bg-indigo-500/10 border border-indigo-500/20 items-center justify-center transition-colors group-hover:bg-indigo-500/15 group-hover:border-indigo-400/40">
                                <Mail className="w-3.5 h-3.5 text-indigo-300" />
                            </span>
                            <span className="text-sm text-slate-300 group-hover:text-white transition-colors tracking-tight">
                                info@quantumgenesislabs.com
                            </span>
                        </a>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="text-[10px] uppercase tracking-[0.32em] text-slate-500 mb-5">Navigate</h4>
                        <ul className="space-y-3 text-sm text-slate-300">
                            {navItems.map((n) => (
                                <li key={n.to}>
                                    <Link
                                        to={n.to}
                                        className="inline-flex items-center gap-1 hover:text-indigo-300 transition-colors"
                                    >
                                        {n.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-6 border-t border-white/5 space-y-4 text-[11px] text-slate-500">
                    <p
                        data-testid="footer-disclaimer"
                        className="max-w-3xl leading-[1.65] text-[11.5px] text-slate-500"
                    >
                        For Research Use Only (RUO). Products are not intended for human consumption or veterinary use. Website content is provided for scientific and informational purposes only and is not medical advice.{" "}
                        <Link
                            to="/faq"
                            data-testid="footer-full-disclaimer-link"
                            className="text-indigo-300/90 hover:text-indigo-200 underline-offset-2 hover:underline transition-colors whitespace-nowrap"
                        >
                            Full Disclaimer
                        </Link>
                    </p>
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                        <p>© {new Date().getFullYear()} Quantum Genesis Labs. All rights reserved.</p>
                        <p>Research use only · Not for human or animal consumption.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
